 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		213: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + {"0":"9cb953d","1":"3fc48de","2":"7b32ef1","3":"5228fc5","4":"5341f9a","5":"bcde724","6":"9dfb5d4","7":"15f6bb0","8":"ecca3d9","9":"fb10957","10":"4c622bf","11":"07bc368","12":"d8a8e76","13":"41fb339","14":"ff1ec3f","15":"0d720f1","16":"13a109f","17":"9fdec36","18":"630de43","19":"7a4cb4b","20":"887ee54","21":"7107180","22":"1a2bd49","23":"9358337","24":"a992e5c","25":"089733a","26":"01ea9c5","27":"7e15f52","28":"d208359","29":"fb8ffda","30":"e6eaeed","31":"2c0491e","32":"95d5dd9","33":"4dc2210","34":"06ae150","35":"b39ffab","36":"ebf9af4","37":"f470621","38":"e1c716e","39":"ec5eb3c","40":"6fe01c6","41":"56e8cff","42":"60746f7","43":"2e74748","44":"5147b17","45":"6561fc5","46":"fad53f9","47":"10d9cc8","48":"cde6479","49":"73101b7","50":"b2aa44e","51":"a8da7c0","52":"d6bf507","53":"d12888b","54":"9d13653","55":"1c95806","56":"ac98deb","57":"eb70962","58":"0ba98bb","59":"ec58670","60":"282f0d8","61":"0ef7f2b","62":"5ac6c73","63":"c3c7a78","64":"31f0cc4","65":"1c43cda","66":"3e3ddd4","67":"58f764a","68":"4dba18a","69":"d72ea94","70":"d4c5dc0","71":"ff82667","72":"61b921a","73":"a6d0a35","74":"0fd3b6a","75":"e236226","76":"c6bf1da","77":"29dfe85","78":"c762420","79":"73dbf99","80":"684d1fd","81":"6ac4407","82":"b00fcfd","83":"b319561","84":"e9c9ee7","85":"3bcfbea","86":"0aeaa49","87":"7a5a851","88":"c4b52ec","89":"36cd3a0","90":"2bf801b","91":"74ba200","92":"3463b67","93":"724106b","94":"94162cd","95":"d7ef511","96":"d3c4a30","97":"ba8d182","98":"20d1385","99":"dc72eb4","100":"6dabbc7","101":"15d0f4f","102":"80e49df","103":"4f5fa7f","104":"2604038","105":"4f1b853","106":"fe7d4cc","109":"7bf8ba6","110":"61069b1","111":"be8f59f","112":"ed74a3d","113":"b2f98bf","114":"af7e2ff","115":"eb1b362","116":"bbb2a47","117":"dd79fc1","118":"fac05eb","119":"d67ce53","120":"84e44fe","121":"1d901ed","122":"f5ad5d9","123":"426be22","124":"848aa0a","125":"ef116e3","126":"dd71601","127":"ca9ffdf","128":"41a3f0a","129":"782519e","130":"fc96c59","131":"b567a0a","132":"55e0ac5","133":"9d34149","134":"edc6a31","135":"677fc87","136":"2526c66","137":"17156e1","138":"6a2d23d","139":"e4f2427","140":"be0a2f2","141":"84112af","142":"f64c1cc","143":"027f5cc","144":"f6e01b0","145":"5ae6c40","146":"6bf045f","147":"493f2b5","148":"b7c28b7","149":"7363d22","150":"daf0ad0","151":"a2a4747","152":"e512815","153":"fafe54f","154":"eac5b77","155":"4d5ed11","156":"aa6aa3c","157":"99f258f","158":"6309546","159":"7bd77f2","160":"05d722e","161":"d61a682","162":"23dfc0b","163":"46357da","164":"0725a6b","165":"ab58e89","166":"3b926ba","167":"8cacfec","168":"9545085","169":"8a64002","170":"ced1bc7","171":"efefaab","172":"7900d94","173":"8c556f5","174":"cd25ffa","175":"4685cd8","176":"ae87710","177":"cb6262a","178":"7e5bcfb","179":"321addc","180":"ad9101f","181":"cd37d50","182":"0ed5825","183":"03db1d3","184":"284e53f","185":"f8c75cc","186":"37bc320","187":"61c1f8f","188":"82b24c4","189":"24bd772","190":"2a6c1fd","191":"af032fb","192":"aad659e","193":"60b8002","194":"d19863b","195":"dfc8ade","196":"6c17d94","197":"675d8cb","198":"5640d27","199":"169b017","200":"a4968cb","201":"75830b9","202":"fee3226","203":"053f2b6","204":"2393a3a","205":"de73c89","206":"2268e25","207":"b50b22a","208":"621db78","209":"4680371","210":"164b690","211":"710809e","212":"1dc26e7","215":"0e5bbb6","216":"09221b6","217":"3c03ea3","218":"64c674e","219":"5cc0fbc","220":"705c399","221":"565c96e","222":"a52dad5","223":"b5437ab","224":"027c0a8","225":"c1041df","226":"4baefd9","227":"3c481f8","228":"8710a74","229":"034dbb1","230":"1a15b60","231":"20923ac","232":"df79ff9","233":"a94bb7d","234":"50f3f53","235":"081296b","236":"0437e26","237":"f61e941","238":"29b230e","239":"4582835","240":"798da69","241":"4f8898e","242":"70e7881","243":"4704c70","244":"862e6bf","245":"fe291bc","246":"1dc31f5","247":"da3b3b1","248":"6a7543e","249":"a95eebb","250":"c4ae634","251":"3217568","252":"ff1f58c","253":"876c676","254":"46cc3d1","255":"dcc447a","256":"54b9d2b","257":"5902749","258":"18897d5","259":"992ba40","260":"cad11af","261":"170b7a5","262":"2c34784","263":"f33fbdc","264":"9138b21","265":"0d59552","266":"a0ec663","267":"b4384c6","268":"ea65011","269":"9993470","270":"045199f","271":"9a78ba6","272":"1ebf40c","273":"53d154e","274":"9c3e3a4","275":"86eaa0f","276":"d5c608f","277":"3161013","278":"a11d331","279":"557d873","280":"108317a","281":"ea759a4","282":"217af9d","283":"637022f","284":"b6e6613","285":"f28ff68","286":"96eaee6","287":"f2fb9ea","288":"50bf5ea","289":"7be3f0f","290":"e269862","291":"42e46df","292":"c2d197b","293":"2fcde3e","294":"9c184b4","295":"a3f7084","296":"ef65298","297":"1a33625","298":"ae6317c","299":"e6cb1c8","300":"891fb28","301":"54d43ee","302":"9033943","303":"92952e1","304":"1475ecd","305":"39d9126","306":"109f319","307":"c84ad76","308":"f47d874","309":"81bbe07","310":"90fa657","311":"62c8257","312":"6ee8450","313":"d9e87e3","314":"4f03085","315":"90d93c6","316":"ddf43ab","317":"e55cde2","318":"b700306","319":"2149cfd","320":"c4bba90","321":"ec48eaf","322":"3213a78","323":"42b0e14"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://d2kaq61j235tiz.cloudfront.net/channels2022/220519/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
